import React from 'react';
import { Store, formatMessage, showDialog, removeScreenData } from 'cw-ui-core';
import _ from 'lodash';
import {
    AUTH_PROVIDER_ENABLE_DIALOG,
    AUTH_PROVIDER_DISABLE_DIALOG,
    AUTH_PROVIDER_DELETE_DIALOG,
    AUTHENTICATION_PROVIDER_ACTIONS,
    EDIT_EXTERNAL_IDP,
} from 'src/features/authentication-v2/constants';
import CheckCircle from '@mui/icons-material/CheckCircle';
import SyncOutlined from '@mui/icons-material/SyncOutlined';
import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import Locale from 'src/i18n';
import { Typography, Stack } from '@mui/material';
import { PERMISSIONS } from 'src/constants';
import { checkIfUserHaveGivenPermissions } from 'src/util/Util';

export const generateErrorsArray = count => {
    return new Array(count).fill(false);
};

export const showAuthProviderActionDialog = (dialogType, providerData) => {
    if (dialogType === AUTHENTICATION_PROVIDER_ACTIONS.enable) {
        Store().dispatch(
            showDialog(AUTH_PROVIDER_ENABLE_DIALOG, {
                providerData,
            })
        );
    }
    if (dialogType === AUTHENTICATION_PROVIDER_ACTIONS.disable) {
        Store().dispatch(
            showDialog(AUTH_PROVIDER_DISABLE_DIALOG, {
                providerData,
            })
        );
    }
    if (dialogType === AUTHENTICATION_PROVIDER_ACTIONS.delete) {
        Store().dispatch(
            showDialog(AUTH_PROVIDER_DELETE_DIALOG, {
                providerData,
            })
        );
    }
};

export const getRedirectURI = scheme => `https://auth.connectwise.com/${scheme}/signin-oidc`;

export const getLogoutURI = scheme => `https://auth.connectwise.com/${scheme}/signout-oidc`;

export const generateLabelForRadio = (title, subtitle) => {
    return (
        <Stack pt={2} pl={1}>
            <Typography variant="body2">{title}</Typography>
            <Typography variant="caption" pl={1}>
                {subtitle}
            </Typography>
        </Stack>
    );
};

export const getTestConfigurationStatus = isValidAuthorityUrl => {
    if (!_.isBoolean(isValidAuthorityUrl)) {
        return {
            icon: <SyncOutlined sx={{ mr: 1 }} />,
            label: formatMessage(Locale.authenticationTestConfiguration),
            status: 'default',
        };
    }

    if (!isValidAuthorityUrl) {
        return {
            icon: <ErrorOutlineOutlined sx={{ mr: 1 }} />,
            label: formatMessage(Locale.invalidAuthorityUrl),
            status: 'error',
        };
    }

    return {
        icon: <CheckCircle sx={{ mr: 1 }} />,
        label: formatMessage(Locale.successAuthorityUrl),
        status: 'success',
    };
};

export const clearAlertMessages = screenKey => {
    Store().dispatch(removeScreenData(['activeAlertMessage'], screenKey));
};

export const shouldDisableAuthInputs = (selectedTab, screenKey) => {
    if (screenKey === EDIT_EXTERNAL_IDP && selectedTab === 1) {
        if (checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_AUTH_UPDATE])) {
            return false;
        }
        return true;
    }
    const isViewAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.AUTHENTICATION_VIEW]);
    const isUpdateAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.AUTHENTICATION_UPDATE]);
    if (isUpdateAvailiable) {
        return false;
    }
    if (isViewAvailiable) {
        return true;
    }
    return false;
};
